import React from 'react';
import { AlertLevelCell, InternalLink } from 'smartsuite-ui';

export default function renderCountLink(
    isCargoEnabled,
    alertLevel,
    bagCount,
    cargoCount,
    bagPath,
    cargoPath,
    hasLinkAccess
) {
    const countCombinationSymbol = ' & ';
    if (isCargoEnabled) {
        if (hasLinkAccess) {
            return (
                <AlertLevelCell alertLevelId={alertLevel}>
                    <a href={bagPath}>{bagCount}</a>
                    {countCombinationSymbol}
                    <a href={cargoPath}>{cargoCount}</a>
                </AlertLevelCell>
            );
        }
        return (
            <AlertLevelCell alertLevelId={alertLevel}>
                <div>
                    {bagCount}
                    {countCombinationSymbol}
                    {cargoCount}
                </div>
            </AlertLevelCell>
        );
    }

    return (
        <AlertLevelCell alertLevelId={alertLevel}>
            <InternalLink href={bagPath} canViewLink={hasLinkAccess}>
                {bagCount}
            </InternalLink>
        </AlertLevelCell>
    );
}
